// extracted by mini-css-extract-plugin
export default {"body":"body-xfrsz","fieldTitle":"fieldTitle-vTEOG","selfAssessWarn":"selfAssessWarn-iyMY1","copyModeSelection":"copyModeSelection-zTUzC"};